// extracted by mini-css-extract-plugin
export default {"body":"TwoSideGrid_body__1BncU","text":"TwoSideGrid_text__uQHrF","image":"TwoSideGrid_image__ETpdg"};